/**
 * Presentation for the labor console's in-app notification types (hrm's notification.constant,
 * cut to what labor-service raises).
 *
 * `notif_type` is a free varchar in public.notifications on purpose — a new producer can raise
 * a new type without a back-end release. These maps only decorate the known ones; anything
 * unrecognised falls back to DEFAULT_NOTIF_* so an unmapped type still renders correctly.
 */

/**
 * `<DOC>_REQUEST` is raised by labor-service's ApprovalNotifier for each approval/ApprovalDocTypeEnum
 * constant, landing in an approver's queue (submitted, advanced, cancelled). There is no _DECISION:
 * the applicant is a worker, who has no login. Adding a doc type to that enum means adding it here.
 */
export const NOTIF_TYPE_LABEL: {[key: string]: string} = {
  WRK_LEAVE_REQUEST: 'Worker Leave Request',
  WRK_ATTENDANCE_REQUEST: 'Worker Attendance Request',
}

/** `_REQUEST` is amber because it means "someone is waiting on you". */
export const NOTIF_TYPE_TONE: {[key: string]: string} = {
  WRK_LEAVE_REQUEST: 'warning',
  WRK_ATTENDANCE_REQUEST: 'warning',
}

export const NOTIF_TYPE_ICON: {[key: string]: string} = {
  WRK_LEAVE_REQUEST: 'event_busy',
  WRK_ATTENDANCE_REQUEST: 'fingerprint',
}

export const DEFAULT_NOTIF_TONE = 'secondary'
export const DEFAULT_NOTIF_ICON = 'notifications'

export const NOTIF_TYPE_OPTIONS = Object.keys(NOTIF_TYPE_LABEL).map((id) => ({
  id,
  title: NOTIF_TYPE_LABEL[id],
}))

export const notifTone = (notifType?: string) => NOTIF_TYPE_TONE[notifType || ''] || DEFAULT_NOTIF_TONE
export const notifIcon = (notifType?: string) => NOTIF_TYPE_ICON[notifType || ''] || DEFAULT_NOTIF_ICON
export const notifLabel = (notifType?: string) => NOTIF_TYPE_LABEL[notifType || ''] || notifType || '—'
